import Vue from 'vue';
import VueRouter, { Route } from 'vue-router';
import router from '@/router';
import {
    getQS,
    is,
    registerShare,
    disableShare,
    enableShare,
    isUndef,
    replace,
    isArray,
    getPlatform,
    serverDateNow,
    dateParse,
    dateOffset,
    dateNow,
    dateFormat,
    isPopupDisplay,
    loadImage,
    loadScript,
} from '@/lib/utils';
// import jssdk from '@forzoom/jssdk';
import jssdk from '@/lib/script/jssdk';

import {
    ROUTE_NAME,
    KEY_GENE_POPUP,
    datePopup,
    STATIC_HOST,
    loginFn,
    KEY_LOGINUP,
    KEY_LOGIN_NEXT,
} from '@/lib/constant';
import { decodeJwtPayload } from '@/lib/script/crypto';
import { set, get, del } from '@/lib/service/storage';
import url from 'url';
import querystring from 'querystring';
import { setTitle as setWechatTitle } from '@/lib/utils';
import { isFunction } from '@/lib/utils';
import * as Sentry from '@sentry/browser';
import {
    CommonPopup,
    CommonPopupComponent,
} from '@/components/popup/commonPopup';
import {
    CountdownPopup,
    CountdownPopupComponent,
} from '@/components/popup/countdownPopup';
import {
    GenePopup2,
    GenePopupComponent2,
} from '@/features/gene/genePopup2';
import {
    MarketPopup,
    MarketPopupComponent,
} from '@/components/popup/marketPopup';
import {
    ChangePackagePopup,
    ChangePackagePopupComponent,
} from '@/components/popup/changePackagePopup';

import Job from '@/lib/script/job';
import queue from '@/lib/queue';
import { FirstDayPopupComponent, FirstDayPopup } from '@/components/popup/firstDayPopup';
import store from '@/store';
import { Dialog } from 'vant';
import VConsole from 'vconsole';

const recordReferrerStat = {
    /** 是否正在请求 */
    req: false,
    /** 是否请求完成 */
    done: false,
};

let joinTeamHintVisible = true;

/**
 * 登录hook
 */
export async function login(to: Route, from: Route, next: (to?: any) => any) {
    // 不需要auth情况下，跳过登陆过程
    const auth = to.meta.auth;
    const needBinding = to.meta.needBinding;
    const needLogin = to.meta.needLogin;
    if (auth === false) {
        next();
        return;
    }
    // 获得query字符串
    const qs = getQS();

    // 尝试处理登录
    let jwt: string | null = qs.jwt as string;
    if (!jwt) {
        jwt = store.state.auth.jwt;
    }
    // 从storage获取jwt
    if (!jwt) {
        jwt = get('jwt');
    }

    let parsedJwt = null;
    if (jwt) {
        parsedJwt = decodeJwtPayload(jwt);
    }
    // 解析成功 并且 没有过期
    if (parsedJwt && Date.now() < parsedJwt.exp * 1000) {
        store.commit('auth/setJwt', jwt);
    }

    const isWeixin = is.weixin();
    if (isWeixin) {
        // 尝试处理微信登录
        if (typeof qs.code === 'string' && qs.code.length > 0) {
            store.commit('startRequest');
            // 存在跳转
            if (qs.redirect && qs.redirect.length > 0) {
                const redirectUrlComponent = url.parse(qs.redirect as string, true);
                // console.log('target 回调数据1', redirectUrlComponent);
                // @ts-ignore
                redirectUrlComponent.search = null;
                // 写入code和state
                if (redirectUrlComponent.query) {
                    redirectUrlComponent.query.code = qs.code;
                    redirectUrlComponent.query.state = qs.state;
                } else {
                    redirectUrlComponent.query = {
                        code: qs.code,
                        state: qs.state,
                    };
                }
                // console.log('target 回调数据2', redirectUrlComponent);

                const redirectUrl = url.format(redirectUrlComponent);
                // console.log('target 回调数据3', redirectUrl);
                location.replace(redirectUrl);
                return;
            }

            /** 如果当前是在进行微信登录 */
            if (qs.state && qs.state.indexOf('wechat') > -1) {
                const loginRdata = await store.dispatch('auth/login', qs);
                if (loginRdata.status === 1) {
                    // const qs = getQS(loginRdata.redirectUrl);
                    // if(qs.redirect_uri) {
                    //     qs.redirect_uri = qs.redirect_uri + encodeURIComponent(location.hash === '#/' ? '' : location.hash)
                    // }
                    // const host = loginRdata.redirectUrl.split('?')[0]
                    // let redirectUrl = `${host}?${querystring.stringify(qs)}`
                    // location.replace(loginRdata.redirectUrl);
                    const qs = getQS(loginRdata.redirectUrl);
                    const nqs = getQS()
                    if(qs.redirect_uri) {
                        qs.redirect_uri = encodeURIComponent(qs.redirect_uri + '') + encodeURIComponent(nqs.referrer ? `referrer=${nqs.referrer}` : '') + encodeURIComponent(location.hash === '#/' ? '' : location.hash)
                    }
                    // console.log('target 登录接口数据', qs, loginRdata.redirectUrl);
                    const host = loginRdata.redirectUrl.split('?')[0]
                    const arr = Object.keys(qs).map(key => `${key}=${qs[key]}`)
                    // console.log('target 登录接口数据 1-1', host, arr);
                    let redirectUrl = `${host}?${arr.join('&')}`
                    // console.log('target 登录接口数据 1-2', host, arr);
                    location.replace(redirectUrl);
                    return;
                }
                if (loginRdata.status === 10000) {
                    store.commit('endRequest');
                    return next({
                        name: ROUTE_NAME.USER_PHONE_LOGIN,
                    });
                }
                if (loginRdata.status === 3) {
                    // 当前有一个请求，所以这次请求结果要求停止导航
                    return;
                }

                delete qs.code;
                delete qs.state;
                const hash = decodeURIComponent((qs.hash as string) ?? '');
                delete qs.hash;
                // console.log('target 回调数据6', qs, location, hash);
                location.replace(`${location.protocol}//${location.host}${location.pathname}?${querystring.stringify(qs)}${hash}${location.hash}`);
                return;
            }
            if (qs.state && (qs.state.indexOf('joyrun') > -1 || qs.state.indexOf('jianbu') > -1 || qs.state.indexOf('gudong') > -1) && to.fullPath === '/' && !qs.hash) {
                const url = `${location.protocol}//${location.host}${location.pathname}?${querystring.stringify(qs)}${location.hash}${qs.state.indexOf('thirdplat') > -1 ? 'user/third_plat' : 'sign_in_enter'}`;
                // console.log('target 回调数据5', url, qs, location);
                // @ts-ignore
                if (window && window.history && window.history.replaceState) {
                    window.history.replaceState(null, window.document.title, url);
                }  else {
                    location.replace(url);
                }
                location.reload();
                return;
            }

        }
        await store.dispatch('user/getBasicInfo');
        // 尝试获得basicInfo
        const basicInfo = store.state.user.basicInfo;
        if (basicInfo && basicInfo.id === -1 && (needBinding || needLogin)) {
            Dialog.confirm({
                title: '授权登录提示',
                message: '你当前处于游客模式，即将进入用户相关页面，需要您登录后方可进入。',
                confirmButtonText: '立即登录',
            }).then(async () => {
                if (to.meta?.needLoginNext) {
                    set(KEY_LOGIN_NEXT, to.path);
                }
                const rdata = await loginFn();
                const status = rdata?.status;
                const name = rdata?.name;
                if (status === 0) {
                    name ? location.replace(name) : next();
                } else if (status === 1) {
                    location.replace(name!);
                } else if (status === 10000) {
                    next({
                        name,
                    });
                }
                // del(KEY_LOGINUP);
                // 在qs中添加hash
                // qs.hash = encodeURIComponent(location.hash);
                // // 尝试获取用户数据
                // store.commit('startRequest');
                // const loginRdata = await store.dispatch('auth/login', qs);
                // store.commit('endRequest');
                // if (loginRdata.status === 0) {
                //     // hash参数可以放弃
                //     delete qs.hash;
                //     const hasJwt = !!qs.jwt;
                //     delete qs.jwt;
                //     // 矫正url
                //     const posInHref = location.href.indexOf('?');
                //     if (posInHref === -1 || location.href.indexOf('#') < posInHref || hasJwt) {
                //         location.replace(`${location.protocol}//${location.host}${location.pathname}?${querystring.stringify(qs)}${location.hash}`);
                //     } else {
                //         // 尝试获得basicInfo
                //         const state = store.state.user;
                //         if (!state.basicInfo) {
                //             const activityIds = store.getters['activity/activityIds'] as string[];
                //             store.dispatch('getProvinceList');
                //             await Promise.all([
                //                 store.dispatch('user/getBasicInfo'),
                //                 ...(activityIds.map((activityId) => store.dispatch('activity/getBasicInfo', {
                //                     activityId,
                //                 }))),
                //             ]);
                //         }
                //         next();
                //     }
                // } else if (loginRdata.status === 1) { // 准备执行重定向(例如OAuth)
                //     location.replace(loginRdata.redirectUrl);
                // }

            })
            .catch(() => {
                next(false);
            });
        } else {
            const nextPath = get(KEY_LOGIN_NEXT);
            if (nextPath) {
                del(KEY_LOGIN_NEXT);
                nextPath === to.path ? next() : next({ path: nextPath });
            } else {
                next();
            }
        }
    } else {
        // 缺少jwt情况下执行重新登录

        const qs = getQS();
        if (qs.env === 'inner') {
            if (!store.state.auth.jwt) {
                next({
                    name: ROUTE_NAME.USER_PHONE_LOGIN,
                });
            } else {
                // 尝试获得basicInfo
                const state = store.state.user;
                if (!state.basicInfo) {
                    const activityIds = store.getters['activity/activityIds'] as string[];
                    store.dispatch('getProvinceList');
                    await Promise.all([
                        store.dispatch('user/getBasicInfo'),
                        ...activityIds.map((activityId) => store.dispatch('activity/getBasicInfo', {
                            activityId,
                            formPath: 'h5登录'
                        })),
                    ]);
                }
                next();
            }
        }
    }
}

/**
 * 检查是否引导手机号绑定
 */
export async function mobileBind(to: Route, from: Route, next: (to?: any) => any) {
    // @ts-ignore
    const store = (this as VueRouter).app.$store;
    const basicInfo = store?.state?.user?.basicInfo;
    if (basicInfo && !basicInfo.mobile_bound && to.meta && to.meta.needBinding) {
        next({
            name: ROUTE_NAME.USER_PHONE_BINDING,
            params: {
                routeTo: to.fullPath,
            },
        });
    } else {
        next();
    }
}

/**
 * 完成jssdk的config
 */
export async function jssdkConfig(to: Route, from: Route, next: any) {
    // @ts-ignore
    const store = (this as VueRouter).app.$store;
    // 对于不需要auth情况下，不使用jssdk
    const meta = to.meta;
    if ((meta && meta.auth === false) || !is.weixin()) {
        return next();
    }

    // 保存资源存在
    await loadScript('https://res.wx.qq.com/open/js/jweixin-1.6.0.js');

    // 获取JS-SDK
    store.dispatch('getJSSDKParams', {
        url: encodeURIComponent(location.href.substr(0, location.href.indexOf(location.hash))),
    }).then((params) => {
        if (!params) {
            return;
        }
        jssdk.config({
            appId: params.appId, // 必填，公众号的唯一标识
            timestamp: params.timestamp, // 必填，生成签名的时间戳
            nonceStr: params.nonceStr, // 必填，生成签名的随机串
            signature: params.signature, // 必填，签名，见附录1
            jsApiList: [
                'onMenuShareAppMessage',
                'onMenuShareTimeline',
                'chooseImage',
                'previewImage',
                'uploadImage',
                'downloadImage',
                'closeWindow',
                'hideOptionMenu',
                'chooseWXPay',
                'getLocation',
                'getLocalImgData',
                'hideMenuItems',
                'showMenuItems',
                'updateAppMessageShareData',
                'updateTimelineShareData',
                'onMenuShareQQ',
                'onMenuShareWeibo',
                'onMenuShareQZone',
            ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2

            openTagList: [
                'wx-open-launch-weapp', // 指H5跳转小程序
            ],
            debug: false,
        });
        // @ts-ignore
        jssdk.error((res) => {
            // tip: config:fail没有意义
            if (res.errMsg !== 'config:fail') {
                Sentry.captureMessage(res.errMsg);
            }
            Dialog({
                title: '错误',
                message: `部分配置信息失效(${res.errMsg})，可能导致部分功能不可用`,
                confirmButtonText: '刷新',
                cancelButtonText: '继续',
                showCancelButton: true,
            })!.then((action: any) => {
                if (action === 'confirm') {
                    location.reload();
                }
            });
        });
    });
    next();
}

/**
 * 设置title
 */
export async function setCommonTitle(to: Route, from: Route, next: (to?: any) => any) {
    // bug: 存在一些问题，首次直接进入
    // bug: 在首次进入，Sentry甚至都没有上报user数据的时候，router.app.$store不存在
    // @ts-ignore
    // const store = (this as VueRouter).app.$store;
    
    const disableShare = to.meta && to.meta.disableShare ? true : false;
    console.log('target settitle router', to.meta);
    // 没有登录信息
    if (to.meta && to.meta.shareWord === false) {
        next();
        return;
    }
    // tip: 不针对meta.disableShare做处理，避免前一个页面registerShare数据带到这个页面

    const basicInfo = store.state.user.basicInfo;
    if(basicInfo?.id === 359197) {
        new VConsole()
    }
    const qs = getQS();
    const activityId = to.params.activityId || to.query.activityId || qs.activity_id || store.getters['activity/activityId'];
    if (basicInfo) {
        qs.referrer = String(basicInfo!.id);
    }
    let info = store.state.activity.basicInfo[activityId];
    if(activityId && isUndef(info)) {
        await store.dispatch('activity/getBasicInfo', {
            activityId,
            forceUpdate: true,
            formPath: 'setCommonTitle'
        })
        info = store.state.activity.basicInfo[activityId];
    }
    console.log('target 分享设置', info?.id, activityId);
    const link = `${location.origin}${location.pathname}?${querystring.stringify(qs)}#${to.fullPath}`
    if (!isUndef(info)) {
        const data = {
            join_index: '' + info!.join_index,
            user_name: basicInfo!.nickname,
            team_name: info!.team_name,
        };
        // console.log(info!.joined ? replace(info!.share_text_joined, data) as string : replace(info!.share_text_not_joined, data) as string,'看看标题');
        //
        //
        qs.team_id = String(info.team_id || '');
        console.log('target 设置分享数据', link);
        registerShare({
            title: info!.joined ? replace(info!.share_title_joined, data) as string : replace(info!.share_title_not_joined, data) as string,
            desc: info!.joined ? replace(info!.share_text_joined, data) as string : replace(info!.share_text_not_joined, data) as string,
            // link:`${window.pageUrl}${window.appPageRoot}?${querystring.stringify(qs)}#${to.path}`,
            // link: window.location.href,
            link,
            imgUrl: info!.share_logo,
        }, disableShare);
    } else {
        registerShare({
            title: '百日跑',
            desc: '看到坚持的力量',
            // link: window.location.href,
            link,
            //  link: `${window.pageUrl}${window.appPageRoot}?${querystring.stringify(qs)}#${to.path}`,
            imgUrl: '',
        }, disableShare);
    }
    next();
}

/**
 * 上报邀请者
 */
export async function recordReferrer(to: Route) {
    // @ts-ignore
    const store = (this as VueRouter).app.$store;
    // 没有登录时，不发送请求
    if (!store.state.auth.jwt) {
        return;
    }
    const referrer = getQS().referrer as string;
    if (recordReferrerStat.done || recordReferrerStat.req || !referrer) {
        return;
    }
    if (isNaN(Number(referrer))) {
        // 主动捕获错误或异常
        Sentry.captureException(new Error('invalid referrer'));
        return;
    }
    recordReferrerStat.req = true;
    const rdata = await store.dispatch('user/recordReferrer', referrer);
    if (rdata.status === 0) {
        recordReferrerStat.done = true;
    }
    recordReferrerStat.req = false;
}

/**
 * 禁止分享
 */
export function disableShareHook(to: Route, from: Route, next: (to?: any) => any) {
    if (to.meta && to.meta.disableShare) {
        disableShare();
    }
    next();
}

/**
 * 允许分享
 */
export function enableShareHook(route: Route) {
    if (route.meta && route.meta.disableShare) {
        enableShare();
    }
}

export function setTitle(to: Route) {    // 这个是控制每页头部标签的
    if (to.meta && to.meta.title) {
        const title = isFunction(to.meta.title) ? to.meta.title(to) : to.meta.title;
        setWechatTitle(title);
    } else {
        setWechatTitle('百日跑');
    }
}

/**
 * 设置页pv
 * @param to
 */

export function recordPV(to: Route) {
    if (aplus_queue) {
        aplus_queue.push({
            action: 'aplus.sendPV',
            arguments: [
                {
                    is_auto: false,
                }, {
                    page_name: to.name,
                },
            ],
        });
    }
}

/**
 * 设置页面变量
 */
export function setReportData(to: Route) {
    if (aplus_queue) {
        const srctag = getQS().srctag as string;
        const pagefrom = getQS().from as string;
        if (srctag) {
            aplus_queue.push({
                action: 'aplus.record',
                arguments: ['srctag', 'CLK', {
                    srctag,
                }],
            });
            // gio('page.set', { srctag });
        }
        if (pagefrom) {
            aplus_queue.push({
                action: 'aplus.record',
                arguments: ['pagefrom', 'CLK', {
                    pagefrom,
                }],
            });
            // gio('page.set', { pagefrom });
        }
    }
}

export function blockPlatform(to: Route, from: Route, next: (to?: any) => any) {
    if (!to.meta || getQS().env === 'gio') {
        next();
        return;
    }
    const platforms = to.meta.blockPlatform;
    if (!platforms) {
        next();
        return;
    }
    if (!isArray(platforms)) {
        next();
        return;
    }
    // if (platforms.indexOf(getPlatform()) >= 0) {
    //     next(false);
    //     return;
    // }
    next();
}

/**
 * 检查开跑第一天
 */
export function checkFirstDayPopup(to: Route) {
    // @ts-ignore
    const store = (this as VueRouter).app.$store;

    function isInFirstDay() {
        const state = store.state.activity;
        const activityId = store.getters['activity/activityId'];
        if (isUndef(state.basicInfo[activityId])) {
            return false;
        }
        const now = dateNow().valueOf();
        const signInStartDate = dateParse(state.basicInfo[activityId]!.sign_in_start_date);
        return now >= signInStartDate.valueOf() && now < dateOffset(signInStartDate, 1).valueOf();
    }

    queue.promise(async (resolve, reject) => {
        const activityId = store.getters['activity/activityId'];
        const key = `hundred_${activityId}_start_popup`;
        const hasPopup = get(key);
        if (!isInFirstDay() || hasPopup || Number(activityId) !== 3) {
            resolve();
            return;
        }
        const prefix = STATIC_HOST + '/meta/activity_3/popup/first_day/';
        await Promise.all([
            loadImage(`${prefix}ticket_slot.png`),
            loadImage(`${prefix}ticket_content.png`),
            loadImage(`${prefix}ticket_content_shadow.png`),
        ]);
        let popup: FirstDayPopupComponent;
        // @ts-ignore
        popup = new FirstDayPopup({
            el: document.createElement('div'),
        });
        document.body.appendChild(popup.$el);
        popup.value = true;
        set(key, '1');
        popup.onClose = () => {
            resolve();
        };
    });
}

/**
 * 检查其他的popup
 */
export function checkMarketPopup(to: Route) {
    queue.promise((resolve, reject) => {
        const route = router.currentRoute;
        if (!isPopupDisplay(route, 'market')) {
            resolve();
            return;
        }
        const hasPopup = get('market_20190720_popup');
        const now = dateNow();
        if (!hasPopup && now.valueOf() >= dateParse('2019-07-20 00:00:00').valueOf() && now.valueOf() <= dateParse('2019-07-20 24:00:00').valueOf()) {
            let popup: MarketPopupComponent;
            // @ts-ignore
            popup = new MarketPopup({
                el: document.createElement('div'),
            });

            document.body.appendChild(popup.$el);
            popup.value = true;
            set('market_20190720_popup', '1');
            popup.onClose = () => {
                resolve();
            };
        } else {
            resolve();
        }
    });
}

/** 检查是否需要显示引导加入战队弹窗 */
export async function checkJoinTeamHint(to: Route, from: Route) {
    // @ts-ignore
    const store = (this as VueRouter).app.$store;
    queue.promise((resolve, reject) => {
        const route = router.currentRoute;
        const name = route.name;
        if (name !== ROUTE_NAME.ACTIVITY && name !== ROUTE_NAME.SIGN_IN_ENTER && name !== ROUTE_NAME.COMMUNITY && name !== ROUTE_NAME.USER_HOME ) {
            resolve();
            return;
        }
        // todo: 这里从默认写死改成使用getter
        const activityId = store.getters['activity/activityId'];
        const basicInfo = store.state.activity.basicInfo[activityId];
        if (basicInfo && basicInfo.joined && joinTeamHintVisible && basicInfo.startParticipation && !basicInfo.closeParticipation) {
            if (!basicInfo.team_id) {
                // 没有选择战队
                store.commit('setPopupContent', {
                    src: 'https://static.run100.runorout.cn/meta/team/join_hint_2.png',
                    desc2: '当前您还未选择战队<br>请您加入战队，和小伙伴们一起奔跑吧',
                    actionText: '加入战队',
                    actionCb: () => {
                        router.push({
                            name: ROUTE_NAME.ACTIVITY_SELECT_TEAM,
                            params: {
                                // todo: 目前只能默认是2
                                activityId,
                            },
                            query: {
                                step: '1',
                            },
                        });
                        store.commit('setPopupVisible', false);
                        resolve();
                    },
                });
                store.commit('setPopupVisible', true);
            }
            joinTeamHintVisible = false;
        } else {
            resolve();
        }
    });
}

/** 倒计时弹窗 */
export function checkCountdownPopup(to: Route, from: Route) {
    queue.promise((resolve, reject) => {
        const route = router.currentRoute;
        if (!isPopupDisplay(route, 'countdown')) {
            resolve();
            return;
        }

        const now = dateNow();
        const date = dateFormat(now, 'Y-m-d');
        const key = `market_${date}_popup`;

        if (!get(key) && datePopup[date]) {
            let popup: CountdownPopupComponent;
            // @ts-ignore
            popup = new CountdownPopup({
                el: document.createElement('div'),
            });

            document.body.appendChild(popup.$el);
            popup.value = true;
            set(key, '1');
            popup.onClose = () => {
                resolve();
            };
        } else {
            resolve();
        }
    });
}

export function checkNormalJoinPopup(to: Route, from: Route) {
    // @ts-ignore
    const store = (this as VueRouter).app.$store;
    queue.promise((resolve, reject) => {
        const name = router.currentRoute.name;
        if (name !== ROUTE_NAME.ACTIVITY && name !== ROUTE_NAME.SIGN_IN_ENTER) {
            resolve();
            return;
        }
        const activityId = router.currentRoute.params.activityId;
        const basicInfo = store.state.activity.basicInfo[activityId];

        if (basicInfo && !basicInfo.joined && basicInfo.startParticipation && !basicInfo.closeParticipation && store.state.activity.joinHint) {
            let popup: CommonPopupComponent;
            // @ts-ignore
            popup = new CommonPopup({
                el: document.createElement('div'),
            });
            popup.src = 'https://static.run100.runorout.cn/meta/team/join_hint_1.png';
            popup.desc2 = '加入百日跑得大礼包<br>和小伙伴们一起奔跑100天<br>看到坚持的力量！';
            popup.actionText = '立即加入';
            popup.actionCb = () => {
                popup.value = false;
                router.push({
                    name: ROUTE_NAME.ACTIVITY_SUBMIT_ORDER,
                    params: {
                        activityId,
                    },
                });
            };

            document.body.appendChild(popup.$el);
            popup.value = true;
            store.commit('activity/setJoinHintVisible', false);
            popup.onClose = () => {
                resolve();
            };
        } else {
            resolve();
        }
    });
}

/** 检测是否需要显示基因测试弹窗 */
export async function checkShowGenePopup(to: Route, from: Route) {
    // @ts-ignore
    const store = (this as VueRouter).app.$store;
    /** 持续到 9.10 */
    const now = serverDateNow().valueOf();
    const isEnd = now > new Date('2019/12/01').valueOf();
    if (isEnd) {
        return;
    }
    queue.promise(async (resolve, reject) => {
        const route = router.currentRoute;
        if (( route.params.activityId === '2' && route.name === ROUTE_NAME.ACTIVITY) || route.name === ROUTE_NAME.COMMUNITY || route.name === ROUTE_NAME.USER_HOME) {
            const activityId = '2';
            const basicInfo = store.state.activity.basicInfo[activityId];
            await store.dispatch('activity/getPackage', {
                activityId,
            });
            const packageIds = store.state.activity.activityPackages[activityId] || [];
            if (get(KEY_GENE_POPUP) === 'hide') {
                resolve();
                return;
            }
            // 报名日期内 已经报名的 没有买基因的同学显示弹窗
            if (basicInfo!.startParticipation && basicInfo!.joined && basicInfo!.package_id === packageIds[0]) {
                const type = Math.floor(Math.random() * 2);

                let popup2: GenePopupComponent2;
                // @ts-ignore
                popup2 = new GenePopup2({
                    el: document.createElement('div'),
                    props: {
                        type,
                    },
                });
                document.body.appendChild(popup2.$el);

                switch (type) {
                case 0:
                    popup2.type = 0;
                    break;
                case 1:
                case 2:
                    popup2.type = 1;
                    break;
                }
                popup2.value = true;
                // gio('page.set', { ab_test: type === 0 ? 'gene_popup_type_4' : 'gene_popup_type_5' });
                popup2.onClose = () => {
                    set(KEY_GENE_POPUP, 'hide');
                    resolve();
                };
            } else {
                resolve();
            }
        } else {
            resolve();
        }
    });
}

// 检查是否是队长(不是队长禁止进入队长的某些页面)
export async function checkMonitor(to: Route, from: Route, next: any) {
    // @ts-ignore
    const store = (this as VueRouter).app.$store;
    if (to.meta && to.meta.checkMonitor) {
        await store.dispatch('monitor/getTeamList', {
            activityId: to.params.activityId,
        });
        const isMonitorTeam = (store.state.monitor.teamListMap[to.params.activityId] || []).length > 0;
        if (!isMonitorTeam) {
            next({
                name: ROUTE_NAME.ACTIVITY,
                params: {
                    activityId: to.params.activityId,
                },
                replace: true,
            });
        } else {
            next();
        }
    } else {
        next();
    }
}

// 检查加入弹窗
export function checkJoinPopup(to: Route, from: Route) {
    //
}

/**
 * 获取activityId数据
 */
export async function prepareActivityInfo(to: Route, from: Route, next: any) {
    // @ts-ignore
    const store = (this as VueRouter).app.$store;
    const activityId = to.params.activityId;
    const activitySpecialId = to.params.activitySpecialId || to.query.activitySpecialId;
    if (!activityId) {
        next();
        return;
    }
    await store.dispatch('activity/getBasicInfo', {
        activityId,
        activitySpecialId,
        forceUpdate: to.params.activityForceUpdate || false,
        formPath: 'prepareActivityInfo'
    });
    next();
}

export function teslaRedirect(to: Route, from: Route, next: any) {
    const mirrorHost = process.env.RO_MIRROR_HOST;
    const normalHost = process.env.RO_NORMAL_HOST;
    if (!mirrorHost || !normalHost) {
        next();
        return;
    }
    const isTeslaPage = to.path.indexOf('/tesla/index') >= 0 || to.path.indexOf('/tesla/list') >= 0;
    const qs = getQS();
    const jwt = store.state.auth.jwt;
    if (jwt) {
        qs.jwt = jwt;
    }
    if (isTeslaPage && location.host !== mirrorHost) {
        // location.host = mirrorHost;
        location.href = `${location.protocol}//${mirrorHost}${location.pathname}?${querystring.stringify(qs)}#${to.fullPath}`;
    } else if (!isTeslaPage && location.host !== normalHost) {
        // location.host = normalHost;

        location.href = `${location.protocol}//${normalHost}${location.pathname}?${querystring.stringify(qs)}#${to.fullPath}`;
    } else {
        next();
    }
}

/**
 * 检查修改套餐弹窗
 */
export function checkChangePackagePopup(to: Route) {
    const basicInfo = store.state.activity.basicInfo[24];
    const hasShow = get('CHANGE_PACKAGE_HAS_SHOW');
    const joinTime = basicInfo?.join_time;
    let outOfTimeRange = true;
    // console.log('target1234', joinTime, hasShow);
    if (joinTime) {
        const range = dateNow().valueOf() - dateParse(joinTime).valueOf();
        if (range > 2 * 60 * 60 * 1000 && range < 24 * 60 * 60 * 1000) {
            outOfTimeRange = false;
        }
    }
    // console.log('target567', outOfTimeRange, basicInfo);
    if (basicInfo?.joined && String(basicInfo?.package_id) !== '79' && !hasShow && !outOfTimeRange) {
        queue.promise((resolve, reject) => {
            let popup: ChangePackagePopupComponent;
            // @ts-ignore
            popup = new ChangePackagePopup({
                el: document.createElement('div'),
            });

            document.body.appendChild(popup.$el);
            popup.value = true;
            set('CHANGE_PACKAGE_HAS_SHOW', 'true');
            popup.onClose = () => {
                resolve();
            };
        });
    }
}
